module.exports = __webpack_public_path__ + "static/media/arrow.3bd0e557.svg";